'use client';

import { c as _c } from "react/compiler-runtime";
import { CaretDown } from '@phosphor-icons/react';
import type { Transition, Variants } from 'motion/react';
import * as m from 'motion/react-m';
import type { PropsWithChildren } from 'react';
import { useState } from 'react';
import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';
import { Button } from '../button/button';
const detailsAnimation = {
  variants: {
    expanded: {
      height: 'auto',
      opacity: 1
    },
    collapsed: {
      height: '0px',
      opacity: 0
    }
  } satisfies Variants,
  transition: {
    ease: 'circOut',
    duration: 0.4,
    opacity: {
      duration: 0.5
    }
  } satisfies Transition
};
const variants = tv({
  slots: {
    content: ''
  },
  variants: {
    contentSpacing: {
      normal: {
        content: 'pb-12'
      },
      small: {
        content: 'pb-10'
      }
    }
  },
  defaultVariants: {
    contentSpacing: 'normal'
  }
});
type TextExpanderProps = PropsWithChildren<{
  readLessLabel?: string;
  readMoreLabel?: string;
  isExpanded?: boolean;
  onExpand?: (isExpanded: boolean) => void;
}> & VariantProps<typeof variants>;
export function TextExpander(t0) {
  const $ = _c(48);
  let children;
  let contentSpacing;
  let props;
  let readLessLabel;
  let readMoreLabel;
  if ($[0] !== t0) {
    ({
      children,
      contentSpacing,
      readLessLabel,
      readMoreLabel,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = contentSpacing;
    $[3] = props;
    $[4] = readLessLabel;
    $[5] = readMoreLabel;
  } else {
    children = $[1];
    contentSpacing = $[2];
    props = $[3];
    readLessLabel = $[4];
    readMoreLabel = $[5];
  }
  const [isExpanded, setIsExpanded] = useState(false);
  let t1;
  if ($[6] !== props) {
    t1 = event => {
      setIsExpanded?.(event.currentTarget.open);
      props.onExpand?.(event.currentTarget.open);
    };
    $[6] = props;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const handleToggle = t1;
  let T0;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[8] !== contentSpacing || $[9] !== handleToggle || $[10] !== isExpanded || $[11] !== props.isExpanded || $[12] !== readLessLabel || $[13] !== readMoreLabel) {
    const classes = variants({
      contentSpacing
    });
    t6 = "group relative overflow-hidden";
    t7 = props.isExpanded ?? isExpanded;
    t8 = handleToggle;
    const t10 = readLessLabel ?? "Weniger lesen";
    let t11;
    if ($[23] !== t10) {
      t11 = <span className="hidden group-open:block">{t10}</span>;
      $[23] = t10;
      $[24] = t11;
    } else {
      t11 = $[24];
    }
    const t12 = readMoreLabel ?? "Mehr lesen";
    let t13;
    if ($[25] !== t12) {
      t13 = <span className="group-open:hidden">{t12}</span>;
      $[25] = t12;
      $[26] = t13;
    } else {
      t13 = $[26];
    }
    let t14;
    if ($[27] !== t11 || $[28] !== t13) {
      t14 = <Button variant="underline" as="span">{t11}{t13}</Button>;
      $[27] = t11;
      $[28] = t13;
      $[29] = t14;
    } else {
      t14 = $[29];
    }
    let t15;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <CaretDown className="size-6 group-open:rotate-180" width={1.5} />;
      $[30] = t15;
    } else {
      t15 = $[30];
    }
    if ($[31] !== t14) {
      t9 = <m.summary className="relative z-10 flex cursor-pointer items-center gap-2 group-open:absolute group-open:bottom-0">{t14}{t15}</m.summary>;
      $[31] = t14;
      $[32] = t9;
    } else {
      t9 = $[32];
    }
    T0 = m.div;
    t3 = detailsAnimation;
    t4 = props.isExpanded ?? isExpanded ? "expanded" : "collapsed";
    t5 = "overflow-hidden";
    t2 = classes.content();
    $[8] = contentSpacing;
    $[9] = handleToggle;
    $[10] = isExpanded;
    $[11] = props.isExpanded;
    $[12] = readLessLabel;
    $[13] = readMoreLabel;
    $[14] = T0;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    T0 = $[14];
    t2 = $[15];
    t3 = $[16];
    t4 = $[17];
    t5 = $[18];
    t6 = $[19];
    t7 = $[20];
    t8 = $[21];
    t9 = $[22];
  }
  let t10;
  if ($[33] !== children || $[34] !== t2) {
    t10 = <div className={t2}>{children}</div>;
    $[33] = children;
    $[34] = t2;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  let t11;
  if ($[36] !== T0 || $[37] !== t10 || $[38] !== t3 || $[39] !== t4 || $[40] !== t5) {
    t11 = <T0 {...t3} animate={t4} className={t5}>{t10}</T0>;
    $[36] = T0;
    $[37] = t10;
    $[38] = t3;
    $[39] = t4;
    $[40] = t5;
    $[41] = t11;
  } else {
    t11 = $[41];
  }
  let t12;
  if ($[42] !== t11 || $[43] !== t6 || $[44] !== t7 || $[45] !== t8 || $[46] !== t9) {
    t12 = <details className={t6} open={t7} onToggle={t8}>{t9}{t11}</details>;
    $[42] = t11;
    $[43] = t6;
    $[44] = t7;
    $[45] = t8;
    $[46] = t9;
    $[47] = t12;
  } else {
    t12 = $[47];
  }
  return t12;
}